import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Paper, Typography, Grid } from '@material-ui/core';
import { Button } from '@ds/react-components';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import ToastMessage from 'common/alert/ToastMessage.js';
import {
  Input,
  RadioButtonGroup,
  Dropdown,
  CheckBox,
  DatePicker,
} from 'common/input/reduxFormComponents.js';

import validate from './addAccountValidation.js';

export const addAccountForm = 'AddAccountForm';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    flex: 1,
    margin: `${theme.spacing(5)}px 200px 0 200px`,
  },
  headings: {
    padding: `${theme.spacing(3)}px 0`,
  },
  form: {
    margin: `${theme.spacing(3)}px auto`,
    width: 540,
    padding: `${theme.spacing(4)}px 95px`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '& button': {
      width: '100%',
    },
    textAlign: 'left',
  },
  subHeading: {
    color: theme.palette.common.darkerText,
    fontWeight: 'normal',
    marginTop: theme.spacing(1),
  },
  seperator: {
    display: 'flex',
    '& p': {
      color: theme.palette.common.inputBorder,
    },
    '& hr': {
      width: 100,
      border: `0.5px solid ${theme.palette.common.inputBorder}`,
    },
  },
});

//if there is not color property in colorOptions items, then 'apperance' props of DropdownSelect takes effect
const colourOptions = [
  { value: 'ocean', label: 'Ocean', isFixed: true },
  { value: 'blue', label: 'Blue', isDisabled: true },
  { value: 'purple', label: 'Purple' },
  { value: 'red', label: 'Red', isFixed: true },
  { value: 'orange', label: 'Orange' },
  { value: 'yellow', label: 'Yellow' },
  { value: 'green', label: 'Green' },
  { value: 'forest', label: 'Forest' },
  { value: 'slate', label: 'Slate' },
  { value: 'silver', label: 'Silver' },
];

const radioOptions = [
  { label: 'male', value: '1' },
  { label: 'female', value: '2' },
  { label: 'other', value: '3' },
];

//This page is not used, it is just a sample page
class AddAccount extends React.Component {
  render() {
    const { classes, handleSubmit, validationError } = this.props; //NOTE: onSubmit prop will become handleSubmit in reduxForm
    return (
      <div className={classes.root}>
        <div className={classes.headings}>
          <Typography variant="h2">Sample Paqe</Typography>
          <Typography variant="h4" className={classes.subHeading}>
            Sample page used to test ReduxForm
          </Typography>
        </div>
        <Paper className={classes.form}>
          {validationError && (
            <ToastMessage type={'error'} message={validationError} />
          )}
          <form name={addAccountForm} onSubmit={handleSubmit}>
            <Grid
              container
              direction="column"
              justify="center"
              alignItems="stretch"
              spacing={2}>
              <Grid item xs={12}>
                <Field
                  name="adfitNo"
                  component={Input}
                  label="Debitsuccess ID"
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="gender"
                  component={RadioButtonGroup}
                  options={radioOptions}
                  label="Gender"
                  onChange={() => {
                    alert('selected');
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="accept"
                  component={CheckBox}
                  label="I agree to the terms and conditions"
                  onChange={() => {
                    alert('checked');
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Field
                  name="date"
                  component={DatePicker}
                  label="Date"
                  dateFormat="dd/MM/yyyy"
                />
              </Grid>
              <Grid item>
                <Field
                  name="colors"
                  component={Dropdown}
                  label="Colour"
                  optionList={colourOptions}
                  isMulti={false}
                />
              </Grid>
              <Grid item>
                <Button text="Next" type="submit" />
              </Grid>
            </Grid>
          </form>
        </Paper>
      </div>
    );
  }
}

AddAccount.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  localisation: PropTypes.object,
};

export default compose(
  withStyles(styles),
  reduxForm({
    form: addAccountForm,
    validate,
    enableReinitialize: true,
  })
)(AddAccount);
